<app-header></app-header>
<section class="privacy-container" [ngStyle]="{'direction':lang==='ar' ? 'rtl' : 'ltr' }">
    <div class="container">
        <h3 class="first-ele"> RoboGarden Inc. Privacy Policy </h3>
        <p>
            At RoboGarden Inc. (“RoboGarden”, “we”, “us” or “our”), we take your privacy seriously. We know that it is
            important for you to know how your personal information will be used and shared. Your use of our website
            (the
            “Website”) and the use of our services (the “Service”) is conditioned on your acceptance of this Privacy
            Policy.
        </p>
        <h3>What information do we collect?</h3>
        <p>When we need “Personal Information” that personally identifies you, we explicitly ask for such information
            when
            you register. Personal Information refers to information such as your name, e-mail address and other
            information
            related to our Service, including a user name and password. Aside from when you register, when you contact
            our
            customer support team, send us other communications, participate in surveys, and/or sign up for our special
            offers or newsletters, your Personal Information may also be collected. Additional information that does not
            constitute Personal Information, such as your IP address, web pages that you have visited, and any other
            data
            normally stored in website logs, may also be collected through using our Website or Service. Any information
            collected automatically through our Website does not include your Personal Information.
        </p>
        <h3> {{'privacy-head-1'|translate}} </h3>
        <p> {{'privacy-p-1' |translate}}
            <a routerLink="/privacyPolicy"> privacy@robogarden.ca </a>
        </p>
        <h3> {{'privacy-head-2'|translate}} </h3>
        <p> {{'privacy-p-2' |translate}} </p>
        <h3>What do we do with your information? </h3>
        <p>RoboGarden will not disclose Personal Information to third parties without your permission or under specific
            circumstances, such as when we believe in good faith that the law requires it. The following describes some
            of
            the circumstances under which your information may be used and disclosed.
        </p>
        <div>
            <ul>
                <li>Using Personal Information to identify and authorize your access to our Website and Service and to
                    audit
                    and improve our Website, Service and features.
                </li>
                <li>To help us operate our Website and Service, we may use and share Information with certain
                    third-parties
                    such as our cloud storage provider, email distribution service providers, and other similar service
                    providers. Such service providers are under an obligation of confidentiality to RoboGarden for the
                    purpose of providing services or products for us on our behalf, including for purposes of analytics,
                    billing and marketing. Except when required to comply with legal requirements or perform services on
                    our
                    behalf, when we do use such third parties, we restrict them from using or disclosing the information
                    that we provide to them and we only provide information that is required to perform such services.
                    Such
                    service providers may send you e-mails on our behalf, but we will not knowingly use any child’s
                    Personal
                    Information for behavioural targeting of advertisements.
                </li>
                <li>We may share billing and account information for credit cards, payment cards or other payment
                    systems
                    collected from clients of paid versions of our service. After they have been forwarded to
                    payment/billing, we do not store credit card or payment card numbers.
                </li>
                <li>We may also collect, using other technologies, information such as your IP address, referring
                    website,
                    browser type, site usage, and whether you opened emails you received from us, all of which is
                    anonymous
                    and non-personally identifiable information.
                </li>
                <li>We only use data collected through usage, which is information such as the numbers and frequency of
                    visitors to the website and includes nothing that would identify you personally, in aggregate form.
                    This
                    aggregate data allows us to make our services attractive to as many users as possible by telling us,
                    for
                    example, how often users use parts of our services. To also provide you with an optimal experience,
                    we
                    may also provide this aggregate information to our partners and our partners may use such
                    information to
                    understand how often and in what ways people use our services. Aggregate information is not
                    disclosed to
                    a partner in a way that would identify you personally.
                </li>
                <li>
                    In limited circumstances, we may be required to share Personal Information with third parties to
                    comply
                    with legal process or requirements, ensuring the security of our services, and preventing fraud or
                    imminent harm.
                </li>
                <li>RoboGarden may disclose information collected from users associated with an educational institution
                    or
                    school board with other users designated by the educational institution, such as teachers and school
                    administrators of that institution.
                </li>
                <li>
                    As long as your account is active, we will retain your Personal Information, or as needed to provide
                    our
                    Service. You may cancel your account at any time using our service interface. If any problem arises
                    when
                    cancelling your account and you wish that we no longer hold or use your Personal Information, please
                    contact us via <a routerLink="/privacyPolicy"> privacy@robogarden.ca </a>. Your Personal Information
                    may also be
                    retained
                    and used as
                    necessary to comply with our legal obligations, enforce our Terms of Service, and resolve disputes.
                </li>
                <li>
                    If RoboGarden becomes involved in a merger, acquisition, or any form of sale of some or all of its
                    assets, your Personal Information may be transferred to the purchaser. In such an event, we will
                    provide
                    notice before personal information is transferred and becomes subject to a different privacy policy.
                </li>
                <li>
                    We do not disclose your Personal Information or share it with third parties except as described
                    herein.
                </li>
            </ul>
        </div>
        <p>If you submit Personal Information to any websites linked on our site, we encourage you to carefully read
            their
            privacy policies. The privacy practices of these websites may differ from ours and your information is
            subject
            to their privacy policies.
        </p>
        <h3> {{'privacy-head-3'|translate}} </h3>
        <p> {{'privacy-p-3' |translate}} </p>
        <p> {{'privacy-p-3-2' |translate}} <a routerLink="/privacyPolicy">info@robogarden.ca</a> . </p>
        <h3> {{'privacy-head-4'|translate}} </h3>
        <p> {{'privacy-p-4' |translate}} </p>
        <h3> {{'privacy-head-5'|translate}} </h3>
        <p> {{'privacy-p-5' |translate}} </p>
        <p> {{'privacy-p-5-1' |translate}} </p>
        <p> {{'privacy-p-5-2' |translate}} </p>
        <h3> {{'privacy-head-6'|translate}} </h3>
        <p> {{'privacy-p-6' |translate}} </p>
        <p> {{'privacy-p-6-1' |translate}} </p>
        <p> {{'privacy-p-6-2' |translate}} </p>
        <p> {{'privacy-p-6-3' |translate}} </p>
        <h3>Changes to this Privacy Policy </h3>
        <p>From time to time, we may amend this Privacy Policy. Use of information we collect now is subject to the
            Privacy
            Policy in effect at the time such information is used. If we make significant changes in the way we treat
            Personal Information, we will post a prominent announcement on our Website and/or send you a message, and if
            necessary, obtain the prior verifiable consent of a parent or legal guardian if changes are made to the way
            we
            use Personal Information. Any significant changes will take effect fourteen (14) days after they are posted
            or
            communicated. After such changes take effect, you are bound by any changes to the Privacy Policy when you
            use
            the Service.
        </p>
        <h3> {{'privacy-head-7'|translate}}</h3>
        <p class="last-p">  {{'privacy-p-7'|translate}} <a routerLink="/privacyPolicy">privacy@robogarden.ca</a>  </p>
    </div>
</section>
<app-subscribe></app-subscribe>

<app-footer></app-footer>